<template>
	<v-container>
		<v-row>
			<v-col
					cols="12"
					sm="10"
					md="8"
					lg="6"
			>
				<v-card outlined>
					<v-toolbar elevation="0">
						<v-toolbar-title v-text="'Новости'" />
						<v-spacer />
						<v-btn
								outlined
								color="green"
								:to="'/articles/create'"
								v-text="'Добавить новость'"
						/>
					</v-toolbar>
					<v-data-table
							:headers="headers"
							:items="articles.data"
							:loading="loading"
							:server-items-length="articles.meta.total"
							loading-text="Загрузка..."
					>
						<template #item.date="{ item }">
							<v-chip
									small
									outlined
									label
									color="blue"
							>
								<v-icon
										small
										left
										v-text="'mdi-calendar'"
								/>
								<span v-text="$formatDate(item.date)" />
							</v-chip>
						</template>
						<template #item.actions="{ item }">
							<v-tooltip top>
								<template #activator="{ on }">
									<v-btn
											icon
											color="blue"
											v-on="on"
											@click="editArticle(item)"
									>
										<v-icon v-text="'mdi-file-edit-outline'" />
									</v-btn>
								</template>

								<span v-text="'Редактировать'" />
							</v-tooltip>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	const HEADERS = [
		{
			text: 'Заголовок',
			value: 'title',
		},
		{
			text: 'Дата',
			value: 'date',
		},
		{
			text: 'Действия',
			value: 'actions',
			align: 'end',
		},
	];

	export default {
		name: 'ArticlesIndex',
		data: () => ({
			loading: false,
			articles: {
				data: [],
				meta: {
					total: 0,
					current_page: 1,
					per_page: 10,
				},
			},
		}),
		computed: {
			headers() {
				return HEADERS;
			},
		},
		mounted() {
			this.getArticles();
		},
		methods: {
			getArticles(options = {}) {
				if (this.loading) {
					return;
				}
				this.loading = true;

				this.$http.get('/api/v1/articles', {
					params: {
						...options,
					},
				})
					.then(response => {
						this.articles = response.data;
					})
					.finally(() => (this.loading = false));
			},
			editArticle(article) {
				this.$router.push(`/articles/${article.slug}`);
			},
		},
	};
</script>

<style scoped>

</style>
